import buttonTextImg from './texts/button_text.png';
import { getAllDeliveryPopupAssetUrls } from './deliveryPopupMood';

export const DELIVERY_POPUP_BUTTON_TEXT_URL = buttonTextImg;

export function getDeliveryPopupAssetUrls(): string[] {
  return [...getAllDeliveryPopupAssetUrls(), buttonTextImg];
}
